import {Component, OnInit} from '@angular/core';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';

@Component({
  template: `<div></div>`
})
export class LogoutComponent implements OnInit {
  constructor(private _auth: AuthService, private _router: Router) {
  }

  ngOnInit(): void {
    this._auth.logout();
    this._router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/logout.component.ts